import AssetFrontendHome from '@/custolink-views/asset_frontend/home/AssetFrontendHome'
import { useAssetFrontendDesign } from './assetFrontendDesign'
import { useHomeModel } from './useHomeModel'
import AssetFrontendHomeDesign from './ForwardTilesHome'

/**
 * The `/` route switch: new or classic design, per `useAssetFrontendDesign`
 * (new design by default; localStorage `design=old` shows the classic one).
 */
export default function AssetFrontendHomeRoute() {
  return useAssetFrontendDesign() ? <HomeDesign /> : <AssetFrontendHome />
}

function HomeDesign() {
  const model = useHomeModel()
  return <AssetFrontendHomeDesign model={model} />
}
